package com.example.socialmediaapp.network

import com.example.socialmediaapp.data.models.Product
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApiListing(
    val id: String,
    @SerialName("seller_id") val sellerId: String,
    @SerialName("seller_name") val sellerName: String = "",
    val title: String,
    val description: String? = null,
    val price: Double,
    val currency: String = "USD",
    @SerialName("image_urls") val imageUrls: List<String> = emptyList(),
    val category: String = "Other",
    val timestamp: Long
) {
    fun toDomain() = Product(
        id = id,
        title = title,
        description = description ?: "",
        price = price,
        currency = currency,
        imageUrls = imageUrls,
        category = category,
        sellerId = sellerId,
        sellerName = sellerName,
        timestamp = timestamp * 1000L
    )
}

@Serializable
data class CreateListingRequest(
    val title: String,
    val description: String,
    val price: Double,
    val currency: String = "USD",
    val imageUrls: List<String> = emptyList(),
    val category: String = "Other"
)

@Serializable
data class CreateListingResponse(val id: String = "")

class MarketplaceRepository(private val api: ApiClient) {

    suspend fun getListings(): Result<List<Product>> = runCatching {
        api.get<List<ApiListing>>("/api/listings").map { it.toDomain() }
    }

    suspend fun createListing(
        title: String,
        description: String,
        price: Double,
        currency: String = "USD",
        imageUrls: List<String> = emptyList(),
        category: String = "Other"
    ): Result<String> = runCatching {
        api.post<CreateListingResponse>(
            "/api/listings",
            CreateListingRequest(title, description, price, currency, imageUrls, category)
        ).id
    }
}
